module.exports = __webpack_public_path__ + "assets/img/reindeer.bf53b079.png";